var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3575 22.913L5.86426 17.1589L8.04525 14.6978L12.4053 18.5617L22.74 9.80078L24.8665 12.3092L12.3575 22.913Z",
    fill: "#1CEA10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 30.5098C6.72898 30.5098 0 23.7764 0 15.4999C0 7.22345 6.72898 0.490234 15 0.490234C23.2709 0.490234 30 7.22362 30 15.4999C30 23.7762 23.271 30.5098 15 30.5098ZM15 3.77867C8.54218 3.77867 3.28842 9.03677 3.28842 15.4999C3.28842 21.9631 8.54218 27.2213 15 27.2213C21.4577 27.2213 26.7116 21.9631 26.7116 15.4999C26.7116 9.03677 21.4577 3.77867 15 3.77867Z",
    fill: "#1CEA10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.bd69316855afc55cc616143622ebaca5.svg";
export { ForwardRef as ReactComponent };